import type { ZodType } from "zod";

export function zodResolver<T>(schema: ZodType<T>) {
  return (values: T): Record<string, string> => {
    const result = schema.safeParse(values);
    if (result.success) return {};
    const errors: Record<string, string> = {};
    for (const issue of result.error.issues) {
      const path = issue.path.map((p) => (typeof p === "number" ? String(p) : p)).join(".");
      if (!(path in errors)) errors[path] = issue.message;
    }
    return errors;
  };
}
